import Styled from 'styled-components'

export default Styled.div`
  position: absolute;
  min-width: 12rem;
  background: ${props => props.theme.colors.white};
  box-shadow: 0 0.25rem 2rem 0 rgba(0, 0, 0, 0.3);
  border-radius: ${props => props.theme.radius};
  z-index: 10;

  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    z-index: 10;
  }

  ${props => ['top'].includes(props.placement) && `
    bottom: calc(100% + 1rem);
  `}

  ${props => ['bottom'].includes(props.placement) && `
    top: calc(100% + 1rem);

    &:after {
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
      border-bottom: 0.5rem solid ${props.theme.colors.gray};
      bottom: 100%;
    }
  `}

  ${props => ['top', 'bottom'].includes(props.placement) && `
    ${['right'].includes(props.align) && `
      right: 0;

      &:after {
        right: 0.5rem;
      }
    `}
  `}
`



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js